// Pure module: only imports ./reviewerSession.ts. Must stay runnable with Node's built-in type stripping.
import { connectWalletDecision, walletGateDecision } from "./reviewerSession.ts"

export type WalletGateResult = { type: "allow" } | { type: "redirect"; to: string } | { type: "mismatch" }

export interface WalletGateDeps {
  isReviewer: () => boolean
  getUserInfo: () => Promise<{ wallet?: string | null; participationRoles?: unknown } | null | undefined>
  getWalletState: () => Promise<{ isConnected: boolean; account?: string | null }>
  disconnectWallet: () => Promise<unknown>
  loadSubscription: () => Promise<{ isActive(): boolean } | null>
  pathname: string
}

export async function runWalletProtectedGate(deps: WalletGateDeps): Promise<WalletGateResult> {
  const isReviewer = deps.isReviewer()
  if (walletGateDecision({ isReviewer }) === "reviewer-readonly") return { type: "allow" }

  const userInfo = await deps.getUserInfo()
  if (!userInfo?.wallet) return { type: "redirect", to: "/create-wallet" }

  const walletState = await deps.getWalletState()
  const decision = walletGateDecision({
    isReviewer,
    wallet: userInfo.wallet,
    isConnected: walletState.isConnected,
    account: walletState.account,
  })

  if (decision === "connect-wallet") return { type: "redirect", to: "/connect-wallet" }

  if (decision === "mismatch") {
    await deps.disconnectWallet()
    return { type: "mismatch" }
  }

  if (deps.pathname !== "/participation-preference") {
    const subscription = await deps.loadSubscription()
    if (subscription?.isActive() && userInfo.participationRoles === null) {
      return { type: "redirect", to: "/participation-preference" }
    }
  }

  return { type: "allow" }
}

export async function runConnectWalletGate(deps: WalletGateDeps): Promise<WalletGateResult> {
  const isReviewer = deps.isReviewer()
  if (connectWalletDecision({ isReviewer }) === "dashboard") return { type: "redirect", to: "/dashboard" }

  const userInfo = await deps.getUserInfo()
  if (!userInfo?.wallet) return { type: "redirect", to: "/create-wallet" }

  const walletState = await deps.getWalletState()
  const decision = connectWalletDecision({ isReviewer, wallet: userInfo.wallet, isConnected: walletState.isConnected })
  if (decision === "dashboard") return { type: "redirect", to: "/dashboard" }

  return { type: "allow" }
}
